import React from 'react';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import styles from './styles.module.scss';

type SinResultadosProductosProps = {
    hasActiveFiltros: boolean
    onClear: () => void
}

const SinResultadosProductos = ({ hasActiveFiltros, onClear }: SinResultadosProductosProps) => (
  <div className={styles.empty}>
    <SearchOffIcon className={styles.emptyIcon} />
    <p className={styles.emptyTitle}>No encontramos productos</p>
    <p className={styles.emptyText}>Probá ajustando o limpiando los filtros seleccionados.</p>
    {hasActiveFiltros &&
      <button type="button" className={styles.emptyClearButton} onClick={onClear}>
        Limpiar filtros
      </button>
    }
  </div>
);

export default SinResultadosProductos;
